import dayjs from 'dayjs';
import { DaySchedule } from '../../../API';
import { v4 as uuidv4 } from 'uuid';
import { API } from 'aws-amplify';
import { addDaySchedule } from '../../../graphql/mutations';
import { ScheduleEvent } from '../../../particles/types/GymSchedules';

export const createDaySchedule = async (schedule: ScheduleEvent, userId: number) => {
  try {
    const dayScheduleResponse = await (API.graphql({
      query: addDaySchedule,
      variables: {
        input: {
          arxReferenceId: uuidv4(),
          name: uuidv4(),
          weekdayId: schedule.weekDayId,
          startTime: dayjs(schedule.start).format('YYYY-MM-DD HH:mm:ss'),
          endTime: dayjs(schedule.end).format('YYYY-MM-DD HH:mm:ss'),
          status: 'active',
          createdBy: userId,
          lastModifiedBy: userId
        }
      }
    }) as Promise<{
      data: { addDaySchedule: DaySchedule };
    }>);
    return dayScheduleResponse.data.addDaySchedule;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
